import { ACTION_TYPE } from '../core/redux/actionType';
import { IAppState } from '../core/redux/IAppState';
import { Action } from 'redux';
import { assoc } from '../language/module';


type SetProductMappingUnsavedEditsAction = {
  type: ACTION_TYPE.SET_PRODUCT_MAPPING_UNSAVED_EDITS;
  hasUnsavedEdits: boolean;
};

/**
 * Makes an action that can be dispatched to record whether the Product Mapping page holds edits that a resort switch
 * would drop. The page owns the flag, so it has to clear it on unmount or the resort selector stays disabled.
 */
export const setProductMappingUnsavedEditsAction = (
  hasUnsavedEdits: boolean,
): SetProductMappingUnsavedEditsAction => ({
  type: ACTION_TYPE.SET_PRODUCT_MAPPING_UNSAVED_EDITS,
  hasUnsavedEdits,
});

export const setProductMappingUnsavedEditsReducer = (state: IAppState, action: Action): IAppState => {

  if (action.type !== ACTION_TYPE.SET_PRODUCT_MAPPING_UNSAVED_EDITS) return state;

  const hasUnsavedEdits = (action as SetProductMappingUnsavedEditsAction).hasUnsavedEdits;

  // The page dispatches this on mount and unmount too, mostly with no change
  if (state.productMappingHasUnsavedEdits === hasUnsavedEdits) return state;

  return assoc('productMappingHasUnsavedEdits', hasUnsavedEdits, state);
}
